<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-tooltip bottom v-model="show">
			<template v-slot:activator="{ on: tooltipActivator }">
				<div v-on="{...tooltipActivator}"> <!-- wyświetla label dla nieaktywnych przycisków -->
					<v-btn v-if="label !== ''"
						@click="click"
						v-on="{...menuActivator}"
						:disabled="disabled"
						:loading="loading"
						icon
						ripple
						style="margin: 0"
						:large="large"
					>

						<v-icon
							:color="color"
							:large="large"
							:small="small"
						>
							{{ icon }}
						</v-icon>
					</v-btn>
				</div>
			</template>
			<span>
				{{ label }}
			</span>
		</v-tooltip>

		<v-btn
			v-if="label === ''"
			@click="click"
			v-on="{...tooltipActivator, ...menuActivator}"
			:disabled="disabled"
			:loading="loading"
			icon
			ripple
			style="margin: 0"
			:large="large"
		>

			<v-icon
				:color="color"
				:large="large"
				:small="small"
			>
				{{ icon }}
			</v-icon>
		</v-btn>
	</div>
</template>

<script>
	export default {
		name: "EgrantyIconButton",

		methods: {
			click() {
				this.$emit("click");
				this.show = false;
			},
		},

		data: function () {
			return {
				show: false
			};
		},

		props: {

			color: {type: String, default: "primary"},
			icon: {type: String},
			label: {type: String, default: ""},
			disabled: {type: Boolean, default: false},
			loading: {type: Boolean, default: false},
			large: {type: Boolean},
			small: {type: Boolean},
			menuActivator: {
				type: Object, default: () => {
				},
			},
			tooltipActivator: {
				type: Object, defualt: () => {
				},
			},
		},
	};
</script>

<style scoped>

.theme--dark .primary--text {
	color: #fff !important;
}

.theme--dark .grey--text {
	color: #71e9dd !important;
}

.theme--dark .grey--text[data-v-efe251fc] {
	color: #fff !important;
}

.theme--dark .red--text {
	color: yellow !important;
}

.theme--dark .blue--text.text--darken-4 {
	color: #9abcf0 !important;
}
</style>
